import { Dialog, Toast } from "vant";
import axios from "axios";
import store from "../store";
import router from "../router";
let env = process.env.NODE_ENV;
let baseURL; 
env = "production";
if (env === "production") {
  baseURL = "http://43.136.85.99:3003";
} else if (env === "development") {
  baseURL = "http://localhost:3003";
} else {
  baseURL = "/api"; // 端口跟本地服务器一致, 或者直接写/api即可,因为请求的时候会自动拼接接口
}

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_URL, // api 的 VUE_APP_URL
  // baseURL, // api 的 VUE_APP_URL
  // baseURL: 'http://localhost:3003',
  baseURL: 'http://43.136.85.99:3003',
  timeout: 50000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
});

// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
  (config) => {
    console.log(config);
    if (store.state.token) {
      // 给请求头添加laohu-token
      config.headers["user-token"] = store.state.token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code == "666") {
      return res;
    } else if (res.code == "603") {
      // code为603代表token已经失效,
      // 提示用户,然后跳转到登陆页面

      Dialog.confirm({
        title: "温馨提示",
        message: "你还没登录,请先登录",
      })
        .then(() => {
          router.push("/login");
        })
        .catch((err) => {
          Dialog.close();
        });

      return Promise.reject({
        message: res.msg,
        code: 603,
      });
    } else {
      return Promise.reject({
        message: res.msg,
      });
    }
  },
  (error) => {
    console.log("error", error);
    return Promise.reject("网络请求错误,请检查网路");
  }
);

export default service;
